import { initContract } from '@ts-rest/core'
import { authContract } from './auth'
import { entitiesContract } from './entities'
import { fulfillmentContract } from './fulfillment'
import { courierContract } from './courier'
import { productContract } from './product'
import { subscriptionContract } from './subscription'
import { orderContract } from './order'
import { paymentContract } from './payment'

export type { ErrorResponse } from './general'

const c = initContract()

export const contract = c.router({
  auth: authContract,
  entities: entitiesContract,
  fulfillment: fulfillmentContract,
  courier: courierContract,
  product: productContract,
  subscription: subscriptionContract,
  order: orderContract,
  payment: paymentContract,
})

export {
  authContract,
  entitiesContract,
  fulfillmentContract,
  courierContract,
  productContract,
  subscriptionContract,
  orderContract,
  paymentContract,
}
